import { msg } from '@lingui/macro';

export const ComplianceRoutes = {
  path: 'compliance/*',
  lazy: () => import('../pages/compliance'),
  handle: {
    name: 'Compliance documents',
    category: 'Compliance',
    title: msg`Compliance documents`,
  },
};
